<template>
    <span>
        <span class="icon">
            <i v-if="gender === 'male'" class="fa fa-mars" />
            <i v-if="gender === 'female'" class="fa fa-venus" />
        </span>
        <span v-if="!onlyIcon">
            <template v-if="gender === 'male'">
                {{ translate("gender.male") }}
            </template>
            <template v-if="gender === 'female'">
                {{ translate("gender.female") }}
            </template>
        </span>
    </span>
</template>

<script>
    import translatorMixin from "./translatorMixin";

    export default {
        name: "gender",
        mixins: [translatorMixin],
        props: ["gender", "onlyIcon"],
    };
</script>

<style scoped></style>
